import { createSlice } from "@reduxjs/toolkit";
import { resetPasswordAPI } from "../../api/auth";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState: data,
  reducers: {
   resetPasswordSlice(state) {
      state.isLoading = true;
    },
   resetPasswordSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    resetPasswordSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   resetPasswordSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const resetPasswordHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(resetPasswordAction.resetPasswordSlice());
    const response: any = await resetPasswordAPI(data);
    
    dispatch(resetPasswordAction.resetPasswordSliceSuccess(response));
  } catch (e: any) {
    dispatch(resetPasswordAction.resetPasswordSliceFailure(e?.response?.data));
  }
};
export default resetPasswordSlice.reducer;
export const resetPasswordAction = resetPasswordSlice.actions;
